import React, { useEffect, useState } from "react";
import Slider from "react-slick";

import Banner1 from "../../../assets/img/banner/banner1.png";
import Banner2 from "../../../assets/img/banner/banner2.png";
import Banner3 from "../../../assets/img/banner/banner5.png";

import "./Banner.css";
import { Link } from "react-router-dom";
import { useGetBannerQuery } from "./bannerSlice";
import axios from "axios";
import { bannerDB } from "../../../rki-data/banner";
import { isMobile } from "react-device-detect";
import { base_url } from "../../../server";
import { useTranslation } from "react-i18next";

const bannerData = bannerDB;
function Banner() {
  const { t } = useTranslation();
  const [data, setData] = useState();
  const baseUrl = base_url();

  var settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}banner/public`, {
        withCredentials: true,
      });
      setData(res.data);
    } catch (error) {
      console.log("Server Error BannerList");
    }
  };
  useEffect(() => {
    getData();
  }, []);

  // Custom Data
  const custom = [
    { id: 1, url: Banner1 },
    { id: 2, url: Banner2 },
    { id: 3, url: Banner3 },
  ];

  return (
    <>
      <section className="bannerSection">
        <Slider {...settings}>
          {data?.length > 3
            ? data.map((item) => {
                return (
                  item?.image?.url && (
                    <Link to={item?.url || ""} key={item._id}>
                      <div className="bannerItemFigure">
                        <img src={item?.image.url} className="img-fluid" />
                        <div className="bannerContent">
                          <h2>{item?.SliderTopHeading}</h2>
                          <p>
                            Borem ipsum dolor sit amet, vim id assentior
                            moderatius nelig
                          </p>
                          <Link
                            className="commonButton bg-white"
                            to={`/${item?.url}`}
                          >
                            {t("See All Collection")}
                          </Link>
                        </div>
                      </div>
                    </Link>
                  )
                );
              })
            : custom.map((item) => {
                return (
                  item?.url && (
                    <Link to={item?.url || ""} key={item.id}>
                      <div
                        className="bannerItemFigure"
                        style={{
                          backgroundImage: `url(${item?.url})`,
                          backgroundSize: "cover",
                          height: "100vh",
                          backgroundPosition: "center"
                        }}
                      >
                        <div className="container">
                          <div className="bannerContent">
                            <h6>Impeccable & Creative</h6>
                            <h2>
                             Transform Your Outdoors with Expert Landscaping                      
                            </h2>
                            <p>
                              Landscaping transforms outdoor spaces into beautiful, functional environments by combining nature, design, and creativity.
                            </p>
                            <Link className="commonButton" to={"/products"}>
                              Find out more
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                );
              })}
        </Slider>
        
      </section>
    </>
  );
}

export default Banner;
